import { AppNS } from 'app';

/**
 * These methods are deprecated for permissions
 * For permission use hasPermission from '/auth/permissions'
 * Use it only to show/hide ambiguous UI sections or bigger elements
 */

export const isInspector = (user: AppNS.User): boolean => {
  return user.roles.includes('inspector');
};

export const isClient = (user: AppNS.User): boolean => {
  return user.roles.includes('client');
};

export const isAgency = (user: AppNS.User): boolean => {
  return user.roles.includes('agency');
};

export const isBackoffice = (user: AppNS.User): boolean => {
  return user.roles.includes('admin') && user.roles.includes('backoffice');
};

export const isGeneral = (user: AppNS.User): boolean => {
  return user.roles.includes('admin') && user.roles.includes('general');
};

export const isAdmin = (user: AppNS.User): boolean => {
  return user.roles.includes('admin');
};

export const getMainRole = (user: AppNS.User): AppNS.Role => {
  return user.roles[0];
};
